/**
 * Ticketing v2 — product page gate (plan §7.6), loaded by product-template.liquid
 * on products tagged `ticket-gated` (diagnostic deposit) or `ticket-linked`
 * (repair service).
 *
 * Gated: Add to cart / Buy it now stay hidden until the backend confirms the
 * link (?ticket=AX-…&k=…) via pay.verify AND the terms checkbox is ticked.
 * The order then carries line-item properties Ticket and Agreed to Terms.
 * Linked: ?ticket=AX-… just adds the Ticket property; nothing is gated.
 */
(function () {
  'use strict';

  const TICKET_RE = /^AX-\d{5,}$/;

  function init() {
    const gate = document.getElementById('ax-ticket-gate');
    if (!gate) return;
    const gated = gate.getAttribute('data-gated') === 'true';
    const blocked = document.getElementById('ax-ticket-blocked');
    const submit = document.querySelector('[data-ax-ticket-submit]');
    const ticketProp = gate.querySelector('[data-ax-ticket-prop]');
    const termsProp = gate.querySelector('[data-ax-terms-prop]');
    const terms = gate.querySelector('[data-ax-terms]');
    const idLabel = gate.querySelector('[data-ax-ticket-id]');

    let params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    const ticket = (params.get('ticket') || '').trim().toUpperCase();
    const k = (params.get('k') || '').trim();

    function attachTicket() {
      ticketProp.value = ticket;
      ticketProp.disabled = false;
      if (idLabel) idLabel.textContent = ticket;
      gate.style.display = '';
    }

    if (!gated) {
      if (TICKET_RE.test(ticket)) attachTicket();
      return;
    }

    if (!TICKET_RE.test(ticket) || !/^[0-9a-f]{16}$/.test(k)) return; // stays blocked

    // A well-formed link: say we're checking until the backend answers.
    const checking = blocked && blocked.querySelector('[data-ax-checking]');
    const blockedMsg = blocked && blocked.querySelector('[data-ax-blocked-msg]');
    function setChecking(on) {
      if (checking) checking.style.display = on ? '' : 'none';
      if (blockedMsg) blockedMsg.style.display = on ? 'none' : '';
    }
    setChecking(true);

    function syncTerms() {
      const ok = terms.checked;
      termsProp.disabled = !ok;
      termsProp.value = ok ? 'Yes – ' + new Date().toISOString().slice(0, 10) : '';
      if (submit) submit.style.display = ok ? '' : 'none';
    }

    fetch(gate.getAttribute('data-api'), {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ action: 'pay.verify', ticketId: ticket, k: k })
    })
      .then(r => r.json())
      .then(res => {
        setChecking(false);
        if (!res || !res.ok || !res.data.valid) return;
        if (blocked) blocked.style.display = 'none';
        attachTicket();
        terms.addEventListener('change', syncTerms);
        syncTerms();
      })
      .catch(() => setChecking(false)); // stays blocked
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
